export default "__VITE_ASSET__B7dHlCNH__"